export const Logo = ({ size = 40 }) => (
  <div className="cx-aura inline-grid place-items-center" data-testid="clipx-logo" style={{ width: size * 1.28, height: size }}>
    <img src="/logo-x.png" alt="CLIP-EX" className="relative object-contain w-full h-full" />
  </div>
);

export const LogoWide = ({ className = "" }) => (
  <div className={`cx-aura inline-block ${className}`} data-testid="clipx-logo-wide">
    <img src="/logo-wide.png" alt="CLIP-EX" className="relative w-full h-auto object-contain" />
  </div>
);

export const LogoFull = ({ className = "", testid = "clipx-logo-full" }) => (
  <div className={`cx-aura cx-aura-lg grid place-items-center ${className}`} data-testid={testid}>
    <img src="/logo-stack.png" alt="CLIP-EX" className="relative w-full h-full object-contain" />
  </div>
);
